import React from 'react'
import Page from './Page'
import processDevelopment from 'carbonlite/data/processDevelopment'

const ProcessDevelopment = () => <Page page={ processDevelopment } />

export default ProcessDevelopment